export var ellipses = '...';
export var previous = '<';
export var next = '>';
